/**
 * @description defines routes for the privacy policy page
 */

import React from 'react';

import PrivacyPolicy from '@seccon/pages/privacyPolicy';

export default [
  {
    path: '/privacyPolicy/index',
    element: (
      <PrivacyPolicy />
    )
  }
];
